import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { RequestSchemaShape } from '../validate';

export const requestApiUrl = '/CvsRequests';
export const requestTemplatesApiUrl = '/RequestTemplates';

const PostRequest = (data: RequestSchemaShape & { captcha?: string | null }) =>
  nzApiAxios.post(requestApiUrl, data).then((response) => response.data);

const GetRequestTemplateCategories = (): Promise<{ id: string; name: string }[]> =>
  nzApiAxios.get(requestTemplatesApiUrl).then((response) => response.data);
const GetRequestTemplates = (id?: string) =>
  nzApiAxios.get(requestTemplatesApiUrl + `/${id}`).then((response) => response.data);

const API = {
  postRequest: PostRequest,
  getTemplateCategories: GetRequestTemplateCategories,
  getTemplates: GetRequestTemplates
};

export default API;
